import { Component, Input } from '@angular/core';
import { RTO_STARTDATE_ENDDATE_WARNING_MESSAGE } from '../../services/realtime-constants';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'nova-rto-warning-message',
    templateUrl: './rto-warning-message.html',
    styleUrls: ['./rto-warning-message.scss'],
    standalone: true,
    imports: [CommonModule, MatIconModule]
})
export class RtoWarningMessageComponent {
    @Input() enabled: boolean;
    @Input() message: string | null = RTO_STARTDATE_ENDDATE_WARNING_MESSAGE;

    // Getter to return the default message if message is null or undefined
    get warningMessage(): string {
        return this.message ?? RTO_STARTDATE_ENDDATE_WARNING_MESSAGE;
    }
}
